import stateProperty from './stateProperty';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'; 


export default {
  state: stateProperty,
  mutations,
  actions,
  getters,
  namespaced: true
};
